<template>
  <div class="xueshu">
    <div class="xuehu-title">
      <titleCard title="学术推广"></titleCard>
    </div>
    <div class="xueshu-content">
      <div class="left animate__animated wow animate__fadeInLeft">
        聚焦肾内和透析领域，专注为医药企业提供全国销售网络的学术推广服务，组织各种规模和形式的学术会议，协调专家资源，引入相关医学、 药学的政府机构和民间组织合作；
        <br> <br> 围绕公益性和学术成果，提高企业的知名度和美誉度，使企业与目标人群建立稳固而长久的互利合作关系，辅助实现企业的长期战略目标。
      </div>
      <div class="right animate__animated wow animate__fadeInRight">
        <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/33BDB45496084C2A93AC3001907777D6-6-2.png" alt="">
      </div>
    </div>
    <div class="xueshu-boxs">
      <div class="box animate__animated wow animate__fadeInDown" data-wow-duration="1.2s">
        <div class="top"><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/3FC65559802245BAB836D0E86CF2512B-6-2.png" alt=""></div>
        <div class="bottom">线上会议</div>
      </div>
      <div class="box animate__animated wow animate__fadeInDown" data-wow-duration="1.4s">
        <div class="top"><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/A5D51515570D4105A856343D4B1082E1-6-2.png" alt=""></div>
        <div class="bottom">线下会议</div>
      </div>
      <div class="box animate__animated wow animate__fadeInDown" data-wow-duration="1.6s">
        <div class="top"><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/D01EFE25E0FF44B1BDC5DBBE0ED33719-6-2.png" alt=""></div>
        <div class="bottom">专题讲座</div>
      </div>
      <div class="box animate__animated wow animate__fadeInDown" data-wow-duration="1.8s">
        <div class="top"><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/10EA76FA3E4942848AD0EC7160D2F927-6-2.png" alt=""></div>
        <div class="bottom">病例直播</div>
      </div>
      <div class="box animate__animated wow animate__fadeInDown" data-wow-duration="2.0s">
        <div class="top"><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/DD263C187B484D1691847BF2E8CCB23C-6-2.png" alt=""></div>
        <div class="bottom">新闻资讯</div>
      </div>
    </div>
    <!-- 往期项目展示 -->
    <div class="wangqi">
      <div class="title">
        <titleCard title="往期项目展示"></titleCard>
      </div>
      <div class="wangqi-content pd animate__animated wow animate__fadeInRight">
        <div class="title">“慢性肾脏病规范诊疗与示范”项目</div>
        <div class="lunbo">
          <div class="swiper-container">
            <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px) !important">
              <div class="swiper-slide" v-for="(item,index) in lunboList1" :key="index">
                <div class="pic">
                  <img :src="item.pic" alt="">
                </div>
                <div class="txt">{{item.txt}}</div>
              </div>

            </div>
            <!-- Add Scrollbar -->
            <div class="swiper-scrollbar"></div>
          </div>
        </div>
      </div>
      <div class="wangqi-content animate__animated wow animate__fadeInRight">
        <div class="title">“曙光闪药 肾爱有加”药学项目</div>
        <div class="lunbo">
          <div class="swiper-container">
            <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px) !important">
              <div class="swiper-slide" v-for="(item,index) in lunboList2" :key="index">
                <div class="pic">
                  <img :src="item.pic" alt="">
                </div>
                <div class="txt">
                  {{item.txt}}
                </div>
              </div>

            </div>
            <!-- Add Scrollbar -->
            <div class="swiper-scrollbar"></div>
          </div>
        </div>
      </div>
    </div>
    <footerCard name="吉老师" phone="135-2108-4802"></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card.vue'
import titleCard from '../../components/title-card.vue'
// 局部引入swiper
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.min';
export default {
  data() {
    return {
      lunboList1: [{
        pic: 'https://yyt-ows.oss-cn-beijing.aliyuncs.com/49BC0D2CB8524BB783C5303B9A8DC6FF-6-2.png',
        txt: '2020年完成8场线下培训'
      }, {
        pic:'https://yyt-ows.oss-cn-beijing.aliyuncs.com/80D393DA00934C049EB9DAD372CD278C-6-2.png',
        txt: '2021年完成8次线上资讯发布'
      },
    ],
      lunboList2: [{
        pic: 'https://yyt-ows.oss-cn-beijing.aliyuncs.com/B6E4B597D7234FA8B4CD84CA2D29668C-6-2.png',
        txt: '药学项目2021年推广活动'
      }, {
        pic: 'https://yyt-ows.oss-cn-beijing.aliyuncs.com/64B7E61F29F84E2F8DB2F8585A4DA9F5-6-2.png',
        txt: '2021年完成一场线下启动会，两场线下交流会，四场线上交流会'
      },
      ]
    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {
    new Swiper('.swiper-container', {
      scrollbar: '.swiper-scrollbar',
      scrollbarHide: false,
      slidesPerView: 'auto',
      // centeredSlides: true,
      spaceBetween: 30,
      grabCursor: true,
    });
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.xueshu {
  .xuehu-title {
    padding: 1rem 0 1.5789rem 0;
  }
  .xueshu-content {
    display: flex;
    margin-bottom: 3.1579rem;
    align-items: center;
    justify-content: center;
    height: 4.6316rem;
    @media screen and (max-width: 540px) {
      display: block;
      padding: 0 16px;
      height: 100%;
      margin-bottom: 20px;
    }
    .left {
      color: #272b2d;
      line-height: 0.4211rem;
      font-size: 0.2316rem;
      width: 8.0526rem;
      box-sizing: border-box;
      padding-right: 1.2211rem;
      @media screen and (max-width: 540px) {
        width: 100%;
        padding: 0 5px;
        font-size: 15px;
        line-height: 26px;
      }
    }
    .right {
      width: 8.0526rem;
      @media screen and (max-width: 540px) {
        width: 100%;
        margin-top: 15px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .xueshu-boxs {
    display: flex;
    height: 7.8947rem;
    background-color: #fbfbfb;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 540px) {
      justify-content: center;
      flex-wrap: wrap;
      height: 100%;
    }
    .box {
      height: 4.6316rem;
      width: 3.1579rem;
      margin: 0 0.1579rem;
      @media screen and (max-width: 540px) {
        height: 162px;
        flex-basis: 122px;
        flex-shrink: 0;
        margin: 0 5px;
        margin-bottom: 16px;
      }
      .top {
        height: 3.7368rem;
        @media screen and (max-width: 540px) {
          height: 80%;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .bottom {
        @media screen and (max-width: 540px) {
          height: 20%;
          line-height: 32px;
          font-size: 12px;
        }
        height: 0.8947rem;
        line-height: 0.8947rem;
        background-color: #0ca6eb;
        color: #fff;
        font-size: 0.2316rem;
        text-align: center;
      }
    }
  }
  .wangqi {
    .title {
      padding: 1.2632rem 0 1.1579rem 0;
    }
    .pd {
      padding-bottom: 1.0526rem !important;
    }
    .wangqi-content {
      padding-left: 1.6842rem;
      padding-bottom: 1.5789rem;
      .title {
        padding-bottom: 0.7579rem;
        font-size: 0.3158rem;
        color: #333333;
        @media screen and (max-width: 540px) {
          font-size: 15px;
          text-align: center;
        }
      }
      .lunbo {
        height: 6.9474rem;
        @media screen and (max-width: 540px) {
          height: 210px;
        }
        .swiper-container {
          height: 100%;
          width: 100%;
        }
        .swiper-wrapper .swiper-slide {
          width: 10.5263rem;
          height: 6.5684rem;
          @media screen and (max-width: 540px) {
            height: 190px;
            width: 300px;
          }
          background-color: #fbfbfb;
          text-align: center;
          .pic {
            padding: 0.3158rem 0.4842rem 0.2632rem 0.4842rem;
            height: 5.5579rem;
            box-sizing: border-box;
            @media screen and (max-width: 540px) {
              height: 160px;
            }
            border-bottom: 1px solid #e6e6e6;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            color: #6a7073;
            padding-top: 0.3368rem;
            font-size: 0.3158rem;
            overflow: hidden;
            @media screen and (max-width: 540px) {
              font-size: 12px;
            }
          }
        }
        .swiper-scrollbar {
          left: 0;
          height: 0.0947rem;
          border-radius: 0;
        }
        /deep/.swiper-scrollbar-drag {
          background: #0ca6eb;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
